import { DriveSubMenuRoutes } from 'modules/Drive/driveSubMenuRoutes';
import { Navigate } from 'react-router-dom';
import { lazyLoad } from 'utils/loadable';

const DrivePage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'QuotationsPage', webpackPrefetch: true */ './index'
  ),
);

const DriveHomePage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'DriveHomePage', webpackPrefetch: true */ './components/DriveHome'
  ),
);

const SharedWithMePage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'SharedWithMePage', webpackPrefetch: true */ './components/SharedWithMe'
  ),
);

export const driveMenuRoutes = allowAdminRoutes => [
  ...(allowAdminRoutes
    ? [
        // {
        //   component: DriveHomePage,
        //   title: 'Home',
        //   path: DriveSubMenuRoutes.HOME,
        // },
        {
          component: DriveHomePage,
          title: 'My Drive',
          path: DriveSubMenuRoutes.MY_DRIVE,
        },
        {
          component: SharedWithMePage,
          title: 'Shared with me',
          path: DriveSubMenuRoutes.SHARED_WITH_ME,
        },
      ]
    : []),
];

// routes declaration

export const DriveRoutes = [
  {
    component: Navigate,
    path: '/drive',

    replace: true,
    to: '/drive' + DriveSubMenuRoutes.DEFAULT,
    toAdmin: '/drive' + DriveSubMenuRoutes.DEFAULT,
    needsAuth: true,
  },
  {
    component: DrivePage,
    path: '/drive/*',
    title: 'Drive',
    needsAuth: true,
  },
];
